<template>
  <div class="app-layout">
    <Sidebar />
      <div class="content">
        <RecommendationMatrix />
      </div>
  </div>
</template>

<script>
import RecommendationMatrix from '@/components/RecommendationMatrix.vue'
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'RecommendationMatrixView',
  components: {
    RecommendationMatrix,
    Sidebar
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  background-color: #f8fafc;
}

.recommendation-container {
  flex: 1;
  padding: clamp(1rem, 2vw, 1.5rem);
  transition: all 0.3s ease;
  width: 100%;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: clamp(1rem, 3vw, 1.5rem);
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.5rem;
}

.header h1 {
  font-size: clamp(1.25rem, 3vw, 1.875rem);
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.2;
}

.content {
  flex: 1;
  margin-left: 280px;
  padding: 2rem;
  width: calc(100% - 280px);
  transition: all 0.3s ease;
}

@media (max-width: 1280px) {
  .content {
    margin-left: 240px;
    width: calc(100% - 240px);
  }
}

@media (max-width: 1024px) {
  .content {
    margin-left: 200px;
    width: calc(100% - 200px);
  }
}

@media (max-width: 768px) {
  .content {
    margin-left: 0;
    width: 100%;
    padding: 1rem;
  }
}

.content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.content::-webkit-scrollbar-track {
  background: transparent;
}

.content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

</style> 